﻿import ko from 'knockout'
import Utility from "../utility"


export default class NullableMoneyObservable {
  constructor(initialValue?: any) {
    var rawValue = ko.observable(initialValue);
    var formatted = ko.computed({
      read: () => {
        var v = Utility.formatMoney(rawValue());
        if ((isNaN(v) || !v) && v !== 0)
          return null;
        return v;
      },
      write: (val) => {
        if (typeof val == "string") {
          var formattedValue = Utility.formatMoney(rawValue());
          rawValue(formattedValue);
        }
        else
          rawValue(val);
      }
    });
    return formatted;
  }
}
